// Reserve the final paragraph, reveal its ink. Never reflow a growing prefix.
const ranges=new WeakMap();
const bounded=(v,max)=>Math.round(Math.max(0,Math.min(max,v))*1000)/1000;
export function revealClip({box,last,count=0,complete=false}){
 if(complete)return 'none';
 if(!count||!box||!last)return 'inset(0 100% 100% 0)';
 const x=bounded(last.right-box.left,box.width),top=bounded(last.top-box.top,box.height),bottom=bounded(last.bottom-box.top,box.height);
 return `polygon(0 0, 100% 0, 100% ${top}px, ${x}px ${top}px, ${x}px ${bottom}px, 0 ${bottom}px)`;
}
export function paintSpeech(node,{text='',fullText='',complete=false}){
 if(node.textContent!==fullText)node.textContent=fullText;
 let clip;
 if(complete||!text.length)clip=revealClip({complete,count:text.length});
 else{
  let range=ranges.get(node);if(!range){range=node.ownerDocument.createRange();ranges.set(node,range);}
  range.setStart(node.firstChild,0);range.setEnd(node.firstChild,Math.min(text.length,fullText.length));
  const rects=range.getClientRects();clip=revealClip({box:node.getBoundingClientRect(),last:rects[rects.length-1],count:text.length,complete});
 }
 if(node.style.clipPath!==clip)node.style.clipPath=clip;
}
